export default class Media {

    constructor(id, name, type, translations){
        this.id = id;
        this.name = name;
        this.type = type;
        this.translations = translations;
    }

    getId(){
        return this.id;
    }

    getName(){
        return this.name;
    }

    getType(){
        return this.type;
    }

    getTranslations(){
        return this.translations;
    }

    setId(id){
        this.id = id;
    }

    setName(name){
        this.name = name;
    }

    setType(type){
        this.type = type;
    }

    setTranslations(translations){
        this.translations = translations;
    }
}